import { vatPrice } from '../../../../../Greativ/helper/price'
import { computed, reactive, readonly, toRefs } from 'vue'
import { httpInstance } from './http'
import _isEqual from 'lodash/isEqual'
import _find from 'lodash/find'

const state = reactive({
  countries: [],
  carriers: [],
  carrierItems: [],
  carrierItemOptions: [],
  selectedCountryId: null,
  selectedCarrierId: null,
  selectedCarrierItemId: null,
  selectedCarrierItemOptionId: null,
  errorKeys: [],
})

let oldTransportCountries = null

export function setTransport(countries) {
  state.selectedCountryId = null
  state.selectedCarrierId = null
  state.selectedCarrierItemId = null
  state.selectedCarrierItemOptionId = null

  const collectCountries = []
  const collectCarriers = []
  const collectCarrierItems = []
  const collectCarrierItemOptions = []
  for (const countryId in countries) {
    const country = countries[countryId]
    collectCountries.push({
      id: countryId,
      name: country.name,
    })
    if (country.selected) {
      state.selectedCountryId = countryId
    }

    for (const carrierId in country.carriers) {
      const carrier = country.carriers[carrierId]
      collectCarriers.push({
        id: carrier.uID,
        ignoreDeliveryData: carrier.ignoreDeliveryData,
        info: carrier.info,
        isParcelMachine: carrier.isParcelMachine,
        logo: carrier.logo,
        name: carrier.name,
        price: carrier.price,
        uID: carrier.uID,
        vat: carrier.vat,
        rank: carrier.rank,
        countryId,
      })
      if (carrier.selected) {
        state.selectedCarrierId = carrier.uID
      }

      if (carrier.options) {
        for (const carrierOptionId in carrier.options) {
          const carrierOption = carrier.options[carrierOptionId]
          collectCarrierItems.push({
            id: carrierOptionId,
            name: carrierOption.groupName,
            carrierId: carrier.uID,
            countryId,
          })

          for (const carrierOptionItemId in carrierOption.items) {
            const optionItem = carrierOption.items[carrierOptionItemId]
            collectCarrierItemOptions.push({
              id: carrierOptionItemId,
              name: optionItem.name,
              carrierId: carrier.uID,
              carrierOptionId,
              countryId,
            })

            if (optionItem.selected) {
              state.selectedCarrierItemOptionId = carrierOptionItemId
              state.selectedCarrierItemId = carrierOptionId
            }
          }
        }
      }
    }
  }

  collectCountries.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  })

  collectCarriers.sort((a, b) => {
    if (a.rank < b.rank) {
      return -1
    }
    if (a.rank > b.rank) {
      return 1
    }
    return 0
  })

  collectCarrierItems.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  })

  collectCarrierItemOptions.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  })

  state.countries = collectCountries
  state.carriers = collectCarriers
  state.carrierItems = collectCarrierItems
  state.carrierItemOptions = collectCarrierItemOptions

  if (collectCountries.length && !state.selectedCountryId) {
    const findEE = _find(collectCountries, { id: '69' })
    if (findEE) {
      state.selectedCountryId = findEE.id

      setTimeout(() => {
        saveTransport().then()
      }, 15)
    }
  }

  /*if (
    collectCountries.length &&
    collectCarriers.length &&
    (!state.selectedCountryId ||
      (oldTransportCountries && !_isEqual(countries, oldTransportCountries)))
  ) {
    oldTransportCountries = countries

    let firstCountryId = null
    let firstCarrierId = null
    let firstCarrierItemId = null
    let firstCarrierItemOptionId = null

    if (window.shop_basket.my_country_id) {
      const country = _find(collectCountries, (country) => {
        return (
          country.id.toString() === window.shop_basket.my_country_id.toString()
        )
      })
      if (country) {
        firstCountryId = country.id
      }
    }
    if (!firstCountryId) {
      firstCountryId = collectCountries[0].id
    }

    collectCarriers.forEach((carrier) => {
      if (carrier.countryId === firstCountryId && !firstCarrierId) {
        firstCarrierId = carrier.id
      }
    })

    if (firstCarrierId) {
      collectCarrierItems.forEach((carrierItem) => {
        if (carrierItem.carrierId === firstCarrierId) {
          firstCarrierItemId = carrierItem.id
        }
      })
    }

    if (firstCarrierItemId) {
      collectCarrierItemOptions.forEach((carrierItemOption) => {
        if (
          carrierItemOption.carrierId === firstCarrierId &&
          carrierItemOption.carrierOptionId === firstCarrierItemId &&
          !firstCarrierItemOptionId
        ) {
          firstCarrierItemOptionId = carrierItemOption.id
        }
      })
    }

    state.selectedCountryId = firstCountryId
    state.selectedCarrierId = firstCarrierId
    state.selectedCarrierItemId = firstCarrierItemId
    state.selectedCarrierItemOptionId = firstCarrierItemOptionId

    setTimeout(() => {
      saveTransport().then()
    }, 15)
  }*/
}

export const countryOptions = computed(() => {
  const collect = []

  state.countries.forEach((country) => {
    collect.push({
      label: country.name,
      value: country.id,
    })
  })

  if (collect.length && !state.selectedCountryId) {
    state.selectedCountryId = collect[0].value
  }

  return collect
})

export const selectedCountryId = readonly(toRefs(state).selectedCountryId)

export function setSelectedCountryId(id) {
  state.selectedCountryId = id
}

export const countryCarrierOptions = computed(() => {
  const collect = []

  const newIds = []
  state.carriers.forEach((carrier) => {
    if (carrier.countryId === state.selectedCountryId) {
      collect.push({
        label: carrier.name,
        value: carrier.id,
        price: carrier.price,
        vat: carrier.vat,
        info: carrier.info,
      })
      newIds.push(carrier.id)
    }
  })

  if (collect.length && !newIds.includes(state.selectedCarrierId)) {
    state.selectedCarrierId = collect[0].value
  }

  return collect
})

export const selectedCarrierId = readonly(toRefs(state).selectedCarrierId)

export function setSelectedCarrierId(id) {
  state.selectedCarrierId = id
}

export const countryCarrierItems = computed(() => {
  const collect = []
  const newIds = []
  state.carrierItems.forEach((carrierItem) => {
    if (carrierItem.carrierId === state.selectedCarrierId) {
      collect.push({
        label: carrierItem.name,
        value: carrierItem.id,
      })
      newIds.push(carrierItem.id)
    }
  })

  /*if (collect.length === 1) {
    state.selectedCarrierItemId = collect[0].value
  } else {
    state.selectedCarrierItemId = null
  }*/

  if (collect.length && !newIds.includes(state.selectedCarrierItemId)) {
    if (collect.length === 1) {
      state.selectedCarrierItemId = collect[0].value
    } else {
      state.selectedCarrierItemId = null
    }
  }
  /*if (collect.length && !newIds.includes(state.selectedCarrierItemId)) {
    state.selectedCarrierItemId = collect[0].value
  }
*/
  return collect
})

export const selectedCarrierItemId = readonly(
  toRefs(state).selectedCarrierItemId
)

export function setSelectedCarrierItemId(id) {
  state.selectedCarrierItemId = id
  setTransportErrorKey('carrier_item', true)
}

export const countryCarrierItemOptions = computed(() => {
  const collect = []
  const newIds = []
  state.carrierItemOptions.forEach((carrierItemOption) => {
    if (
      carrierItemOption.carrierId === state.selectedCarrierId &&
      carrierItemOption.carrierOptionId === state.selectedCarrierItemId
    ) {
      collect.push({
        label: carrierItemOption.name,
        value: carrierItemOption.id,
      })
      newIds.push(carrierItemOption.id)
    }
  })

  /* if (collect.length && !newIds.includes(state.selectedCarrierItemOptionId)) {
    state.selectedCarrierItemOptionId = collect[0].value
  }*/

  if (collect.length === 1) {
    state.selectedCarrierItemOptionId = collect[0].value
  } else if (
    collect.length &&
    !newIds.includes(state.selectedCarrierItemOptionId)
  ) {
    state.selectedCarrierItemOptionId = null
  }

  return collect
})

export const selectedCarrierItemOptionId = readonly(
  toRefs(state).selectedCarrierItemOptionId
)

export function setSelectedCarrierItemOptionId(id) {
  state.selectedCarrierItemOptionId = id
  setTransportErrorKey('carrier_item_option', true)
}

export async function saveTransport(countryId, uId, itemId) {
  const filledCountryId = countryId || state.selectedCountryId
  const filledUID = uId || state.selectedCarrierId
  const filledValue = itemId || state.selectedCarrierItemOptionId
  try {
    await httpInstance.post('transport', {
      country_id: filledCountryId,
      uID: filledUID,
      value: filledValue,
    })
  } catch (error) {
    console.error(error)
  }
}

export const transportTotalPrice = computed(() => {
  let price = 0

  state.carriers.forEach((carrier) => {
    if (carrier.id === state.selectedCarrierId) {
      price = carrier.price
    }
  })

  return price
})

export const transportTotalVatPrice = computed(() => {
  let price = 0

  state.carriers.forEach((carrier) => {
    if (carrier.id === state.selectedCarrierId) {
      price = vatPrice(carrier.price, carrier.vat)
    }
  })

  return price
})

export const transportTotalVat = computed(() => {
  let vat = 0
  state.carriers.forEach((carrier) => {
    if (carrier.id === state.selectedCarrierId) {
      vat = vatPrice(carrier.price, carrier.vat) - carrier.price
    }
  })
  return vat
})

export const selectedCountryName = computed(() => {
  let countryName = ''

  state.countries.forEach((country) => {
    if (country.id === state.selectedCountryId) {
      countryName = country.name
    }
  })

  return countryName
})

export const isSelectedCarrierParcelMachine = computed(() => {
  let isParcelMachine = false

  state.carriers.forEach((carrier) => {
    if (carrier.id === state.selectedCarrierId && carrier.isParcelMachine) {
      isParcelMachine = true
    }
  })

  return isParcelMachine
})

export const isSelectedCarrierParcelIgnoreDeliveryData = computed(() => {
  let isIgnore = false
  state.carriers.forEach((carrier) => {
    if (carrier.id === state.selectedCarrierId) {
      isIgnore = carrier.ignoreDeliveryData
    }
  })

  return isIgnore
})

export const checkTransport = () => {
  let anyErrors = false
  if (countryCarrierItems.value.length && !selectedCarrierItemId.value) {
    setTransportErrorKey('carrier_item', false)
    anyErrors = true
  }

  if (
    countryCarrierItemOptions.value.length &&
    !selectedCarrierItemOptionId.value
  ) {
    setTransportErrorKey('carrier_item_option', false)
    anyErrors = true
  }

  return !anyErrors
}

export const transportErrorKeys = readonly(toRefs(state).errorKeys)

export const setTransportErrorKey = (key, remove = false) => {
  if (remove) {
    const index = state.errorKeys.indexOf(key)
    if (index > -1) {
      state.errorKeys.splice(index, 1)
    }
  } else if (!state.errorKeys.includes(key)) {
    state.errorKeys.push(key)
  }
}
